// extracted by mini-css-extract-plugin
export default {"contentPageBodyDescription":"content-page-body-description__content-page-body-description__t6BgQ"};